import React, { useEffect, useLayoutEffect } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import cookie from 'react-cookies';
import useDevice from '@/utils/hooks/device';

import { fetchLoadData, REQUEST_LOAD_DATA } from '@/modules/User';
import { actions } from '@/modules/Socket';
import {
  fetchActiveOlimpics,
  REQUEST_GET_OLIMPIC_ACTIVE,
} from '@/modules/Olimpic';
import { useSnackbarListener } from './utils/hooks/snackbar';

/**
 * Init.
 * @param {object} values values.
 */
const Init = ({ authenticated, loadData, init, requests }) => {
  useEffect(() => {
    cookie.save('language', 'en');

    if (authenticated && !init) {
      loadData();
    }
  }, []);

  const { setSize } = useDevice(window.innerWidth);

  useLayoutEffect(() => {
    function updateSize() {
      setSize(window.innerWidth);
    }
    window.addEventListener('resize', updateSize);
    updateSize();
    return () => window.removeEventListener('resize', updateSize);
  }, []);

  useSnackbarListener(
    (requests[REQUEST_LOAD_DATA] || requests[REQUEST_GET_OLIMPIC_ACTIVE])
      ?.errorMessage
  );

  return <div style={{ display: 'none' }} />;
};

Init.propTypes = {
  init: PropTypes.bool.isRequired,
  loadData: PropTypes.func.isRequired,
  requests: PropTypes.object.isRequired,
  authenticated: PropTypes.bool.isRequired,
};

const mapStateToProps = state => ({
  init: state.user.init,
  authenticated: state.user.token !== '',
  requests: state.requests,
});

const mapDispatchToProps = dispatch => ({
  loadData() {
    dispatch(fetchLoadData());
    dispatch(fetchActiveOlimpics());
  },
  sconnect() {
    dispatch(actions.socketConnect());
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(Init);
